import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { dealTypeFromJsonQuery } from '../../../packages/JsonQuery';

export const selectDealType = createSelector(selectJsonQuery, jsonQuery => dealTypeFromJsonQuery(jsonQuery));
